import request from '@/utils/request';
import { obj2query } from '@/utils'


export function getMainRules(companyuid, projectuid) { 
  return request({
    url: `/api/firewall/rule/main/${companyuid}/${projectuid}`,
    method: "get" 
  })
}

export function putMainRules(data, companyuid, projectuid) {
  return request({
    url: `/api/firewall/rule/main/${companyuid}/${projectuid}`,
    method: "put",
    data
  })
}

export function getCustomRuleList(query, projectuid) { 
  return request({
    url: `/api/firewall/rule/custom/${projectuid}/lists${obj2query(query)}`,
    method: "get",
  })
}

export function postSearchCustomRules(data) { 
  return request({
    url: `/api/firewall/rule/custom`,
    method: "post",
    data
  })
}
export function getCustomRules(plusuid) { 
  return request({
    url: `/api/firewall/rule/custom/${plusuid}`,
    method: "get"
  })
}

export function postCustomRules(plusuid, data) { 
  return request({
    url: `/api/firewall/rule/custom/${plusuid}`,
    method: "post",
    data
  })
}

export function putCustomRules(plusuid, data) { 
  return request({
    url: `/api/firewall/rule/custom/${plusuid}`,
    method: "put",
    data
  })
}

export function deleteCustomRules(plusuid) { 
  return request({
    url: `/api/firewall/rule/custom/${plusuid}`,
    method: "delete" 
  })
}